import React, { useMemo, useState } from 'react'
import { Button, Checkbox, Modal, Table } from 'antd'
import type { GeoItem } from './types'

const { Column } = Table

interface PreviewProps {
  geoItems: GeoItem[]
  onImportClick: () => void
  onLocationsErrorClick: () => void
  onAdjust: (record: GeoItem) => void
}

const Preview: React.FC<PreviewProps> = ({
  geoItems,
  onImportClick,
  onLocationsErrorClick,
  onAdjust
}) => {
  const [isOnlyError, setIsOnlyError] = useState(false)
  const failedItems = useMemo(
    () => geoItems.filter((record) => record.status === 0),
    [geoItems]
  )
  const successItems = useMemo(
    () => geoItems.filter((record) => record.status === 1),
    [geoItems]
  )
  const noLocationItems = useMemo(
    () => geoItems.filter((record) => record.status === 2),
    [geoItems]
  )
  const errorNum = failedItems.length + noLocationItems.length

  const records = useMemo(() => {
    let _records: GeoItem[] = []
    if (isOnlyError) {
      _records = [...failedItems, ...noLocationItems]
    } else {
      _records = geoItems
    }

    return _records.map((record, index) => ({
      ...record,
      key: index + 1
    }))
  }, [isOnlyError, geoItems, failedItems, noLocationItems])

  return (
    <div className="preview-wrapper">
      <div className="import-info">
        <div className="info-title">选项信息预览</div>
        <div className="info-content">
          <div className="info-left">
            <span>
              上传选项数：<i>{geoItems.length}</i>
            </span>
            <span>
              定位成功：<i>{successItems.length}</i>
            </span>
            <span>
              定位失败，无法匹配：{' '}
              <i style={{ color: '#D40000' }}>{failedItems.length}</i>
            </span>
            <span>
              无定位：<i>{noLocationItems.length}</i>
            </span>
            <span>
              <Checkbox
                onChange={(e) => {
                  setIsOnlyError(e.target.checked)
                }}
              >
                仅显示失败
              </Checkbox>
            </span>
          </div>
          <div className="info-right">
            <Button
              type="primary"
              onClick={() => {
                if (errorNum > 0) {
                  Modal.confirm({
                    content: `有${errorNum}个条目定位失败，是否继续导入其他条目`,
                    cancelText: '去调整',
                    okText: '继续导入',
                    onOk: onImportClick,
                    zIndex: 10000
                  })
                } else {
                  onImportClick()
                }
              }}
            >
              确认导入
            </Button>
            <Button onClick={onLocationsErrorClick}>下载定位失败客户</Button>
          </div>
        </div>
      </div>
      <div className="table-container">
        <Table
          bordered
          dataSource={records}
          scroll={{ y: window.innerHeight - 402 }}
          style={{ margin: '0 20px' }}
          pagination={false}
        >
          <Column
            title="序号"
            key="key"
            dataIndex="key"
            render={(key: number) => {
              return key
            }}
          />
          <Column title="选项名称" key="content" dataIndex="content" />
          <Column title="关联经度" key="lng" dataIndex="lng" />
          <Column title="关联纬度" key="lat" dataIndex="lat" />
          <Column title="关联拍照地址" key="address" dataIndex="address" />
          <Column
            title="定位状态"
            key="status"
            dataIndex="status"
            render={(text: 0 | 1 | 2) => {
              if (text === 0) {
                return <span style={{ color: '#D40000' }}>失败</span>
              } else if (text === 1) {
                return <span>成功</span>
              } else if (text === 2) {
                return <span>无定位</span>
              }
            }}
          />
          <Column
            title="操作"
            render={(_text: unknown, record: GeoItem) => {
              return (
                <a
                  onClick={() => onAdjust(record)}
                  style={{ color: '#0093FF' }}
                >
                  调整定位
                </a>
              )
            }}
          />
        </Table>
      </div>
    </div>
  )
}

export default Preview
